import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Icon, { ICON_PLUS_LINE } from '~/components/icon/index.js';
import {
	AddGameButtonButtonWrapper,
	AddGameText,
	AddGameIconContainer
} from '~/components/casino-shared/game-loader/multi-game/add-game-button-styles';
import useTranslations from '~/components/translation/use-translations.ts';
import { getAllGameSlotsSelector } from '~/components/casino-shared/game-loader/ducks/selectors';
import { useCasinoSharedSelector } from '~/components/casino-shared/ducks/types';
import { setIsModalShown as setIsMultiGameSearchModalShown } from '~/components/casino-shared/game-loader/multi-game/ducks';

const textKeys = ['MULTI_GAME_ADD_GAME_BTN_TEXT'];

const AddGameButton = ({ isDesktop, orientation }) => {
	const dispatch = useDispatch();
	const { translations } = useTranslations(textKeys);
	const allGameSlots = useCasinoSharedSelector(getAllGameSlotsSelector) || {};

	const isAllSlotsFilled = Object.values(allGameSlots)?.every(slot => slot?.gameLoaderResponse);

	const openSearchModal = useCallback(() => {
		dispatch(setIsMultiGameSearchModalShown(true));
	}, [dispatch]);

	if (isDesktop) {
		return null; // Do not render the button on desktop for now
	}

	return (
		<AddGameButtonButtonWrapper
			data-at="add-game-button"
			isDesktop={isDesktop}
			orientation={orientation}
			isDisabled={isAllSlotsFilled}
			onClick={openSearchModal}
		>
			<AddGameIconContainer isDesktop={isDesktop} orientation={orientation}>
				<Icon width={20} height={20} type={ICON_PLUS_LINE} />
			</AddGameIconContainer>
			<AddGameText isDesktop={isDesktop} orientation={orientation} isDisabled={isAllSlotsFilled}>
				{translations.MULTI_GAME_ADD_GAME_BTN_TEXT}
			</AddGameText>
		</AddGameButtonButtonWrapper>
	);
};

export default AddGameButton;
